export const phoneNumberCanadaUSA = "1-877-815-7751"; // our simply phone number
export const phoneNumberSupport = "+18778157751";
export const phoneNumberInternational = "1-519-251-0152";
export const publicSiteUrl = "simplybenefits.ca";
export const appStore = "https://apps.apple.com/us/app/simply-benefits/id1494221810";
export const playStore = "https://play.google.com/store/apps/details?id=com.simplybenefits.app&hl=en_US";
export const phoneNumbers = {
  'Orion': {
    northAmerica: '1-888-997-0152',
    international: '1-519-251-0152'
  },
  'La Capitale': {
    northAmerica: '1-855-747-7764',
    international: '1-418-747-7714'
  },
  'AIG': {
    northAmerica: '1-877-204-2017',
    international: '1-715-295-9962'
  },
  'Empire': {
    northAmerica: '1-855-537-1722',
    international: '416-814-7605'
  },
  'HumanaCare': {
    number: '1-800-661-8193'
  },
  'Advica': {
    number: ''
  },
  'Assure': {
    number: '1-800-668-1608'
  },
  'Desjardins': {
    northAmerica: '1-800-465-6390',
    international: '800-29-48-53-99'
  }
};
export const adminEmail = "administration@simplybenefits.ca";
export const supportEmail = "support@simplybenefits.ca";
export const contactEmail = "contact@simplybenefits.ca";
export const claimsEmail = "claims@simplybenefits.ca";
export const simplyAddress = "601-460 Doyle Ave Kelowna BC, V1Y 0C2";
export const termsAndConditions = `Simply Benefits Inc. (“us”, “we”, or “Simply Benefits”) is committed to privacy and the protection of your information. By using Simply Benefits’s website, mobile and other applications, and related Services made available through the Apple App Store, the Google PLAY Store, or otherwise on the Internet (together, the “Simply Benefits Applications” or “Applications”), you acknowledge that you accept the practices and policies outlined in this Privacy Policy (“Privacy Policy“). Unless otherwise defined herein, capitalized terms shall have the meanings assigned to such terms set forth in the Terms of Service and which incorporate this Privacy Policy by reference.`;
export const privacyPolicy = `At Simply Benefits Corp ("Simply Benefits") we are concerned with safeguarding and protecting the privacy of your personal information. In accordance with Canada's *Personal Information Protection & Electronic Documents Act* ("PIPEDA") we have established policies on how we collect, use and protect any information that you give us when you use our website or services.

What We Collect
Required Regulatory Information
Simply Benefits collects information needed to provide services and meet the regulatory requirements of our industry. When you open an account or sign up for services, we collect personal information which may include but is not limited to the following:

Your name and date of birth
Contact details
Nature of your employment or business
Details about your dependents
Demographics
Other information relevant to the services we provide
Passive Data Collection
We may receive passively-collected information through a variety of methods, including “cookies” to collect information.

What is a cookie?

Cookies are text files containing small amounts of information which are downloaded to your device when you visit a website. Cookies are then sent back to the originating website on each subsequent visit, or to another website that recognizes that cookie. You can get more information about cookies here.

Simply Benefits uses cookies to track and measure site performance and gather analytics on usage. This information is anonymous and is only used by Simply Benefits to measure and improve our site.

When sending e-mail we may use tracking pixels and urls to help us measure open rates for e-mails and link clicks. This tracking information is used internally only to help us provide relevant content and is never shared with any third parties.

Opting Out of Cookies

If you choose, you may set your browser to notify you when you receive a cookie, giving you the chance to decide whether or not to accept it.

Analytics And Marketing

We use analytics tools and other third party technologies, such as Google Analytics, to collect non-personal information in the form of various usage and user metrics when you use our online Sites and/or Services.

We also use online advertising to reach new potential clients and remarketing tools that allow us to target ads to specific groups of people who have previously interacted with WealthBar’s websites.

Google allows individuals to opt out of it’s advertising cookies from its ad settings page.

Google has additional information available about their Remarketing Privacy Guidelines, and Restrictions.

Where do we store it
Simply Benefits may use third parties to store and process data. Simply Benefits will ensure that such third party service providers have significant expertise with data and digital privacy. Simply Benefits will ensure that personal data is stored and transmitted in encrypted format using technology such as SSL. Third party data storage and processing providers may be located in the United States and as a result personal information may be subject to U.S. privacy law which may differ from Canadian privacy law.

How We Use It
The information we collect is used so we can communicate with you, provide benefits and insurance management services, improve our products and services, and meet our regulatory obligations.

We share only the information which is reasonably required in the normal course of business with third parties such as our custodians, securities regulators, auditors, legal counsel, or law enforcement agencies, to enable them to fulfill their obligations to Simply Benefits and our clients. We may also disclose your personal information to third-party service providers, affiliates and agents in order to assist us in providing the services you requested and to fulfil the purposes for which your personal information has been collected. Outside of this we shall not sell, distribute or lease your personal information to third parties unless we have your permission or are required by law to do so.

How We Protect It
We are committed to ensuring that your information is secure. In order to prevent unauthorized access or disclosure, we have put in place suitable physical, electronic and managerial procedures to safeguard and secure the information we collect online. In the event that we share your personal information with third-party service providers, affiliates and agents, these parties will be required to adhere to strict confidentiality obligations and practices.

If you have a question, concern or complaint about our privacy policy, please send your comments and your contact details to our Privacy Officer in writing to the following address:

Simply Benefits Corp. 601-460 Doyle Ave Kelowna BC, V1Y 0C2

compliance@simplybenefits.ca

If you believe that any information we have on file for you is incorrect or incomplete, please write to or email us as soon as possible, at the above address. We will promptly correct any information found to be incorrect.`;
export const lsaOptions = {
  Health: ['Massage Units', 'Medic Alert Bracelet/Neck Chain', 'Smoking Cessation Programs', 'Sun Care', 'Vitamins and Supplements', 'Weight Loss Programs'],
  Alternative: ['Aromatherapy', 'Craniosacral', 'Holistic Medicine or Practitioner', 'Meditation Classes', 'Reflexology', 'Reiki'],
  Cosmetic: ['Cosmetic Dentistry', 'Cosmetic Dermatology', 'Cosmetic Procedures', 'Hair Replacement', 'Teeth Whitening'],
  Personal: ['Child Daycare Services', 'CPR Training', 'Language Programs', 'Parking', 'Transportation Expense', 'Personal Development Course', 'Cell Phone', 'Professional Membership', 'Life Coach', 'Legal Fees', 'Financial Advisor Fees', 'RRSP/RESP Contribution Reimbursement'],
  FitnessAndSports: ['Dance Lessons', 'Fitness Equipment', 'Fitness Trackers', 'Golf (green fees)', 'Gym Membership', 'Horseback Riding', 'Kids Sports Fees', 'Personal Training', 'Self-defense Course', 'Ski Passes', 'Sporting Goods', 'Yoga, Pilates, Barre', 'Ergonomic Office Equipment', 'Active Wear', 'Flotation Therapy (float tank)'],
  Other: ['Doula Services', 'Elder Care', 'Handicapped Parking Permit', 'Lactation Consulting', 'Personal Protective Equipment', 'Pet Daycare', 'Pet Insurance', 'Prenatal Education Classes', 'Safety Glasses', 'Camping Fees', 'Treatment Centre/Spas', 'Cleaning Services', 'Veterinary Fees', 'Spa Services', 'Non-prescription Glasses/Sunglasses']
};